export default __webpack_public_path__ + "static/media/ok.2186034c.svg";